"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assessmentSchema = void 0;
var accrued_interest_calculation_schema_1 = require("./accrued-interest-calculation-schema");
var credit_of_receipt_interest_calculation_schema_1 = require("./credit-of-receipt-interest-calculation-schema");
exports.assessmentSchema = {
    type: 'object',
    required: [
        'receivedDefaultInterestRatePercent',
        'receivedLastCompleteInstallmentPaidDueDate',
        'receivedOutstandingPrincipalBalanceAmount',
        'receivedTaxAccountBalanceAmount',
    ],
    properties: {
        acceptableDefaultInterestRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        acceptableDeficiencySaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        acceptableDeficiencySaleCommissionAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        acceptableDeficiencySalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        acceptableLastCompleteInstallmentPaidDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        acceptableOutstandingPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        acceptableTaxAccountBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        adjustedConveyancingDateLenderNotificationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        adjustedDefaultInterestRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        adjustedDeficiencySaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        adjustedDeficiencySaleCommissionAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        adjustedDeficiencySalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        adjustedLastCompleteInstallmentPaidDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        adjustedOutstandingPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        adjustedTaxAccountBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        approvedLastCompleteInstallmentPaidDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        approvedOutstandingPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        approvedTaxAccountBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        previouslyApprovedConveyancingDateLenderNotificationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        previouslyApprovedDefaultInterestRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        previouslyApprovedDeficiencySaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        previouslyApprovedDeficiencySaleCommissionAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        previouslyApprovedDeficiencySalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        previouslyApprovedLastCompleteInstallmentPaidDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        previouslyApprovedOutstandingPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        previouslyApprovedTaxAccountBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        receivedLenderNotificationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        receivedDefaultInterestRatePercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        receivedDeficiencySaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        receivedDeficiencySaleCommissionAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        receivedDeficiencySalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        receivedLastCompleteInstallmentPaidDueDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        receivedOutstandingPrincipalBalanceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        receivedTaxAccountBalanceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 5 digits of precision or null',
        },
        accruedInterestCalculations: {
            type: ['array', 'null'],
            items: accrued_interest_calculation_schema_1.accruedInterestCalculationSchema,
        },
        creditOfReceiptInterestCalculations: {
            type: ['array', 'null'],
            items: credit_of_receipt_interest_calculation_schema_1.creditOfReceiptInterestCalculationSchema,
        },
    },
};
